// Opening the booking site.
//
// One function, used by the patient's own Appointments screen and by a
// guardian booking for a dependent, because the two flows differ in exactly one
// thing: whose appointment it is. Everything else — the clinic app's address,
// the location in the path — is identical, and a second copy would be one more
// place for the dev/production address rule to drift.
//
// Nothing is minted (blhWebServer ADR 0022 step 4). The booking site signs in
// through the platform: the portal's sign-in IS the site's, the same patient
// session on its cookie, so opening it needs no token of its own. It used to
// mint a booking-site session (`POST /book-now/session`) and hand it over in
// `?token=`, where it sat in history and in every Referer.
//
// The SUBJECT is not decided here. A dependent is named in the fragment
// (`#for=`), which the browser sends to no server: a request, never a claim.
// The site chooses them only among the people the guardian may book for, and
// every booking door asks the guardianship policy again.

/**
 * The booking site's address, for the patient or a dependent.
 *
 * @param {object} state        app state (carries `organization`)
 * @param {string} [patientId]  who the booking is for; omit for self
 * @param {string} [locationId] pre-selected site
 * @returns {string}
 */
export function createBookingWizardUrl(state, {patientId, locationId} = {}) {
  const path = locationId ? `/onlineBooking/${encodeURIComponent(locationId)}` : "/onlineBooking";
  // In development the clinic app runs on :3001; in production it is the
  // organization's own address.
  const isLocal =
    window.location.hostname === "localhost" || window.location.hostname === "127.0.0.1";
  const base = isLocal ? "http://localhost:3001" : `https://${state.organization?.url}`;
  const fragment = patientId ? `#for=${encodeURIComponent(patientId)}` : "";

  return `${base}${path}${fragment}`;
}
